// Libs
import axios from 'axios';
import { SubmissionError } from 'redux-form'

// Actions
import { changeLocalLoading, changeErr } from '../App/actions'
import { changeFirstTime } from '../Auth/actions'
import { signIn } from '../SignInPage/actions'

// Axios
import { serverAPI } from '../../index'

export function signUp(reduxFormData, history) {
  return function (dispatch) {
    dispatch(changeLocalLoading(true))
    return serverAPI.post('/user/sign-up', reduxFormData)
      .then(response => {
        dispatch(changeFirstTime(true))
        dispatch(signIn({ email: reduxFormData.email, password: reduxFormData.password, type: 'sign-up', history }))
      })
      .catch((e) => {
        dispatch(changeLocalLoading(false))
        switch (e.response.status) {
          case 800:
            throw new SubmissionError({
              email: 'Este email já está cadastrado.'
            })
          case 801:
            throw new SubmissionError({
              oabNumber: `Esta OAB já está cadastrada.`
            })
          case 802:
            throw new SubmissionError({
              oabNumber: `Esta OAB já está cadastrada.`
            })
          case 806:
            dispatch(changeErr(`Esta OAB já está cadastrada. Acesse o seu email ${e.response.data.email} para começar a usar a plataforma.`))
            break;
          default:
            dispatch(changeErr('Desculpe, os servidores estão em manutenção no momento. Em algumas horas iremos retomar as atividades.'))
        }
      })
  }
}
